"use strict";

var abp = abp || {};

(function () {
  function isStorefront() {
    var basePath = new URL(document.baseURI).pathname.replace(/\/$/, '');
    var routePath = window.location.pathname.slice(basePath.length);
    return routePath === '' || routePath === '/' || /^\/store(?:\/|$)/.test(routePath);
  }

  var storefrontBusyCount = 0;
  var storefrontOverlay;

  if (!FreezeUI || !UnFreezeUI) {
    return;
  }

  abp.ui.setBusy = function (elm, text, delay) {
    if (isStorefront()) {
      storefrontBusyCount++;
      if (!storefrontOverlay) {
        storefrontOverlay = document.createElement('div');
        storefrontOverlay.className = 'shop-loading-overlay';
        storefrontOverlay.setAttribute('role', 'status');
        storefrontOverlay.setAttribute('aria-live', 'polite');
        storefrontOverlay.innerHTML = '<div class="shop-loading-content">' +
          '<div class="shop-loading-bag" aria-hidden="true"><span></span></div>' +
          '<p class="shop-loading-title">Your store</p>' +
          '<p class="shop-loading-caption">Getting things ready for you</p>' +
          '<div class="shop-loading-track" aria-hidden="true"><span></span></div></div>';
        document.body.appendChild(storefrontOverlay);
      }
      return;
    }
    FreezeUI({
      element: elm,
      text: text ? text : " ",
      delay: delay
    });
  };

  abp.ui.clearBusy = function (elm, delay) {
    if (storefrontBusyCount > 0) {
      storefrontBusyCount--;
      if (!storefrontBusyCount && storefrontOverlay) {
        storefrontOverlay.remove();
        storefrontOverlay = null;
      }
      return;
    }
    UnFreezeUI({
      element: elm,
      delay: delay
    });
  };
})();
